import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ shape, spacing, palette, zIndex }: Theme) => {
  const commonAbsoluteStyles = {
    backgroundColor: colors.white.lightest,
    borderRadius: shape.borderRadius,
    boxShadow: '0 6px 12px rgba(0,0,0,.175)',
    minWidth: '100%',
    position: 'absolute' as const,
    top: 42,
    zIndex: zIndex.modal + 1,
  };

  return createStyles({
    root: {},
    label: {
      display: 'inline-block',
      color: colors.grey.darker,
      fontSize: 14,
      marginBottom: spacing(3),
    },
    search: {
      position: 'relative',
    },
    textField: {
      width: '100%',
    },
    textFieldInput: {},
    list: {
      ...commonAbsoluteStyles,
    },
    optionsList: {
      maxHeight: 215,
      overflowX: 'hidden',
      padding: spacing(2, 0),
    },
    listAbove: {
      top: 'auto',
      bottom: 42,
    },
    listItem: {
      padding: spacing(2, 4),

      '&:hover': {
        backgroundColor: colors.grey.body,
        color: palette.primary.main,
        cursor: 'pointer',
      },
    },
  });
};
